import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Error404 from "../Error404";
import PageIndex from "./Index";

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={PageIndex} />
    <Route component={Error404} />
  </Switch>
);
